/**
 * ComposedInputCollector.js — User Input Collector
 *
 * Shows UI for collecting required user input when ActionExecutor
 * returns 'awaiting_input' status. Currently supports ally target
 * selection for social effects.
 *
 * Part of the Composable Mechanic Engine (Issue #82, Phase A: #176)
 */

import React from 'react';
import { DomainCardButton } from '../components/domain-cards/ui';
import AllyTargetSelector from '../components/party/AllyTargetSelector';

/**
 * @param {object} props
 * @param {object} props.inputSpec - Input requirements from ActionExecutor
 * @param {function} props.onSubmit - Callback: (userInput) => void
 * @param {function} props.onCancel - Callback: () => void
 */
const ComposedInputCollector = ({ inputSpec, onSubmit, onCancel }) => {
  if (inputSpec.type === 'ally_target') {
    return (
      <div className="mt-2 p-2 bg-gray-700/50 rounded border border-purple-600/30">
        <p className="text-xs text-purple-300 mb-2">Select a target ally:</p>
        <div className="flex items-center gap-2">
          <AllyTargetSelector
            onSelect={(ally) => onSubmit({ allyId: ally.characterId })}
            label="Select Target"
            variant="support"
            showVitals={true}
          />
          <DomainCardButton
            onClick={onCancel}
            variant="secondary"
          >
            Cancel
          </DomainCardButton>
        </div>
      </div>
    );
  }

  // Unknown input type — return null for future extensibility
  return null;
};

export default ComposedInputCollector;
